<template>
    <div>
        <div class="bg--img bg--brands-that-trust-us wash heavy">
            <h1 class="text-center pad-top--xl pad-bottom--xl z-up text-white">
                Check Out - Addresses
            </h1>
        </div>
        <form v-on:submit="goToPayment">
        <div class="grid-container pad-top--large">
            <div class="grid-x grid-padding-x">
                <div class="cell small-12 medium-7">
                    <h5 class="text-blue">Invoice address</h5>
                    <div class="grid-x grid-padding-x">
                        <div class="cell small-12 medium-6">
                            <input
                                class="login-field"
                                v-model="invoiceAddress.name"
                                required
                                type="text"
                                placeholder="Name">
                        </div>
                        <div class="cell small-12 medium-6">
                            <input
                                class="login-field"
                                v-model="invoiceAddress.email"
                                required
                                type="email"
                                placeholder="Email">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x">
                        <div class="cell small-12 medium-6">
                            <input
                                class="login-field"
                                v-model="invoiceAddress.contactNumber"
                                type="text"
                                placeholder="Contact number">
                        </div>
                        <div class="cell small-12 medium-6">
                            <input
                                class="login-field"
                                v-model="invoiceAddress.lineOne"
                                type="text"
                                placeholder="Address line one">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x">
                        <div class="cell small-12 medium-6">
                            <input
                                class="login-field"
                                v-model="invoiceAddress.lineTwo"
                                type="text"
                                placeholder="Address line two">
                        </div>
                        <div class="cell small-12 medium-6">
                            <input
                                class="login-field"
                                v-model="invoiceAddress.town"
                                type="text" 
                                placeholder="Town">
                        </div>
                    </div>
                    <div class="grid-x grid-padding-x">
                        <div class="cell small-12 medium-6">
                            <input
                                class="login-field"
                                v-model="invoiceAddress.postCode"
                                type="text" 
                                placeholder="Postcode">
                        </div>
                        <div class="cell small-12 medium-6">
                            <label>
                                <input
                                    v-on:change="useInvoiceAddress"
                                    type="checkbox"
                                    checked>
                                    Deliver to invoice address
                            </label>
                        </div>
                    </div>
                    <br />
                    <div v-if="deliverToInvoice === false">
                        <h5 class="text-blue">Delivery address</h5>
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 medium-6">
                                <input
                                    class="login-field"
                                    v-model="deliveryAddress.lineOne"
                                    type="text"
                                    placeholder="Address line one">
                            </div>
                            <div class="cell small-12 medium-6">
                                <input
                                    class="login-field"
                                    v-model="deliveryAddress.lineTwo"
                                    type="text"
                                    placeholder="Address line two">
                            </div>
                        </div>
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 medium-6">
                                <input
                                    class="login-field"
                                    v-model="deliveryAddress.town"
                                    type="text" 
                                    placeholder="Town">
                            </div>
                            <div class="cell small-12 medium-6">
                                <input
                                    class="login-field"
                                    v-model="deliveryAddress.postCode"
                                    type="text" 
                                    placeholder="Postcode">
                            </div>
                        </div>
                        <div class="grid-x grid-padding-x">
                            <div class="cell small-12 medium-6">
                                <textarea
                                    class="login-field"
                                    v-model="deliveryAddress.notes"
                                    placeholder="Any notes for the delivery driver">
                                </textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="cell small-12 medium-5 pad-bottom--xl">
                    <div class="bordered light shadowed pad">
                        <div class="cart-progress">
                            <span class="one active"></span>
                            <span class="two active"></span>
                            <span class="three"></span>
                        </div>
                        <h5 class="text-right pad-top">Summary</h5>
                        <hr />
                        <div
                            v-for="(item, index) in basket"
                            v-bind:key="index"
                            class="grid-x">
                            <div class="cell small-12 medium-3">
                                <img
                                    v-bind:src="`https://our-catalogue.com/RUNS/images/${item.product_code}.jpg?width=100`"
                                    alt="" />
                            </div>
                            <div class="cell small-12 medium-6">
                                <p class="small text-light pad-left">
                                    {{ item.product_code }}
                                </p>
                                <p class="small text-light pad-left">
                                    Colour <span class="float-right">{{ item.colour }}</span><br />
                                    Size<br />
                                    <span
                                        v-for="(size, index) in item.size"
                                        v-bind:key="index"
                                        class="text-heavy">
                                        {{ size }}
                                    <br /></span>
                                    Method <span class="float-right">{{ item.method }}</span><br />
                                    Customize <span class="float-right">{{ item.design_id }}</span><br />
                                </p>
                            </div>
                            <div class="cell small-12 medium-3">
                                <p class="text-right text-heavy">
                                    &pound;{{ item.price + ( item.design_price / 100 ) | numeral('0,0.00') }} X {{ item.quantity }}
                                </p>
                            </div>
                            <div class="cell small-12">
                                <hr />
                            </div>
                        </div>
                        <table class="fixed">
                            <tbody>
                                <tr>
                                    <th>SubTotal</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ basketSubTotal | numeral('0,0.00') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>VAT</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ basketVatTotal | numeral('0,0.00') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Delivery</th>
                                    <td>&nbsp;</td>
                                    <td class="price-cell text-right">
                                        &pound;{{ deliveryPrice | numeral('0,0.00') }}
                                    </td>
                                </tr>
                                <tr>
                                    <th>Total</th>
                                    <td colspan="2" class="text-right">
                                        &pound;{{ (deliveryPrice + basketSubTotal + basketVatTotal) | numeral('0,0.00') }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <button
                            class="button tall green expanded">Proceed To Payment
                        </button>
                    </div>
                </div>
            </div>
        </div>
        </form>
    </div>
</template>

<script>
export default {
    name: 'Addresses',
    data() {
        return {
            invoiceAddress: {
                name: '',
                email: '',
                contactNumber: '',
                lineOne: '',
                lineTwo: '',
                town: '',
                postCode: '',
            },
            deliveryAddress: {
                lineOne: '',
                lineTwo: '',
                town: '',
                postCode: '',
                notes: '',
            },
            deliverToInvoice: true,
        };
    },
    computed: {
        basket() {
            return this.$store.getters.basketItems;
        },
        basketSubTotal() {
            return this.$store.getters.basketSubTotal;
        },
        deliveryPrice() {
            return this.$store.getters.deliveryPrice;
        },
        basketVatTotal() {
            return this.$store.getters.basketVatTotal;
        },
    },
    methods: {
        useInvoiceAddress() {
            if (this.deliverToInvoice === false) {
                this.deliverToInvoice = true;
                this.deliveryAddress.lineOne = this.invoiceAddress.lineOne;
                this.deliveryAddress.lineTwo = this.invoiceAddress.lineTwo;
                this.deliveryAddress.town = this.invoiceAddress.town;
                this.deliveryAddress.postCode = this.invoiceAddress.postCode;
            } else {
                this.deliverToInvoice = false;
                this.deliveryAddress.lineOne = '';
                this.deliveryAddress.lineTwo = '';
                this.deliveryAddress.town = '';
                this.deliveryAddress.postCode = '';
            }
        },
        goToPayment(event) {
            event.preventDefault();
            const addressData = {};
            addressData.invoice = this.invoiceAddress;
            addressData.delivery = this.deliveryAddress;
            this.$store.dispatch('saveAddresses', addressData);
            this.$router.push('/checkout/payment');
        },
        populateAddresses() {
            this.invoiceAddress = this.$store.getters.invoiceAddress;
            this.deliveryAddress = this.$store.getters.deliveryAddress;
        },
    },
    mounted() {
        this.populateAddresses();
    },
};
</script>
                    


// WEBPACK FOOTER //
// src/components/CheckOut/Addresses.vue